import fetchWeb3dApi from '@/service/web3dApi';
import { useIntl, useModel } from '@umijs/max';
import { isLogin } from '@/models/userInfo';
import { initLogin } from '@/utils/access';
import { CommonMessage } from 'AssetShareComponents';
import useExitMinDetail from './exitMinDetail';

interface FavoritesProps {
  setIsFavorite: (isFavorite: boolean) => void;
  removeMaterial?: (id: string) => void;
  setCollectInfo?: (info: any) => void;
}
/**
 * @description 自定义 Hook 用于处理收藏操作
 */
export const useFavorites = (props: FavoritesProps) => {
  const { setIsFavorite, removeMaterial } = props;
  const { formatMessage } = useIntl();
  const { setShowCategoryManager, toggleUnfavorite } = useModel('favorites')
  const { updateRecommendDetail } = useModel('recommend')

  const exitMinDetail = useExitMinDetail()
  const favoritesOperation = async (item: any) => {
    try {
      if (!isLogin) {
        initLogin(() => {
          setShowCategoryManager({ show: true, dragId: item.dragId, item, id: item.id });
        })
        return
      }
      if (!item?.isFavorite) {
        exitMinDetail()
        setTimeout(() => {
          // 打开收藏夹管理
          setShowCategoryManager({ show: true, dragId: item.dragId, item, id: item.id });
        }, 100);
      } else {
        const res = await fetchWeb3dApi({
          url: 'Favorite/DeleteFavorie',
          method: 'post',
          query: {
            moduleName: 'Platform_DesignMaterial_Like',
            objectId: item?.dragId,
            isPublic: 1,
          },
        });

        if (res?.code === 0) {
          updateRecommendDetail(item?.id, 'isFavorite', false)
          // 收藏成功后的逻辑
          CommonMessage({
            type: 'success',
            content: formatMessage({ id: '取消收藏成功' }),
            key: 'isFavorite'
          });
          toggleUnfavorite(item.dragId)
          item.isFavorite = false;
          setIsFavorite(false);
          if (item.categoryname === '收藏夹') {
            removeMaterial?.(item?.dragId);
          }
        }
      }
    } catch (err) {
      console.warn('Error during favorites operation:', err);
    }
  };

  return { favoritesOperation };
};
